import { BaseService, RequestType } from "@intech/react-service";
import { LGPDConsentimentoEntidade } from "../entidades";

class LGPD extends BaseService {

  constructor() {
    super("LGPD");
  }

  Buscar = () =>
    this.CreateRequest<Array<LGPDConsentimentoEntidade>>(RequestType.GET);

  Inserir = (origem: number) =>
    this.CreateRequest<string>(RequestType.POST, `${origem}`);
}

export const LGPDService = new LGPD();